exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);

// module
exports.push([module.id, "body{height:100%}.navbar{height:6.5rem;background-color:#0277bd;padding:1rem}.navbar .logo,.navbar .nav-links{display:inline-block}.navbar .logo{color:#f5f5f5;margin-right:50%}.navbar .nav-links span{color:#f5f5f5;font-size:1.6rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/navbar/navbar.scss
// module id = 384
// module chunks = 0